import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSkeleton = _resolveComponent("BaseSkeleton")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_BaseSkeleton, _mergeProps({
        key: 0,
        type: _ctx.skeleton ? _ctx.skeleton : 'text',
        class: _ctx.classes
      }, _ctx.$attrs), null, 16, ["type", "class"]))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _mergeProps({
        key: 1,
        class: ["base-text", _ctx.classes]
      }, _ctx.$attrs), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 16, ["class"]))
}